const validate = values => {
  // (2, _('Карта СберБанка')),
  // (3, _('Карта Альфа-Банка')),
  const cardPaymentMethods = [2, 3];
  const errors = {}
  if (cardPaymentMethods.includes(Number(values.payment_method))) {
    if (!values.card_expire){
      errors.card_expire = gettext('Обязательное поле.');
    } else{
      const params = values.card_expire.split('/');
      const dateValue = new Date(`${ params[0] }/01/${ params[1] }`)
      const dateNow = new Date();
      if (dateValue < dateNow){
        errors.card_expire = gettext('Срок окончания действия карты уже истек.');
      }
    }
  }
  return errors;
}

export default validate;